import Jimp from "jimp";

class ConvertUtils {
  constructor(file, canvas, dispatch, options) {
    this.result = '';
    this.options = Object.assign({}, {
      endian: false,
      invert: false,
      dither: false,
      threshold: 33,
      mirror: false//vertical      
    }, options);
    this.width = 0;//原始宽
    this.height = 0;
    this.file = file;
    this.canvas = canvas;
    this.dispatch = dispatch;
    this.context = null;
    this.image = null;
    this.imageData = null;

    this.convert = this.convert.bind(this);
    this.convertToHex = this.convertToHex.bind(this);
    this.pickColor = this.pickColor.bind(this);
    this.invertColor = this.invertColor.bind(this);
    this.getBitmapArray = this.getBitmapArray.bind(this);
    this.reverseBit = this.reverseBit.bind(this);
  }

  convert() {
    if (!this.file) return;
    // console.log(JSON.stringify(this.options));
    this.context = this.canvas.getContext('2d');
    this.image = new Image();
    this.image.src = this.file;

    const loadImage = () => {
      return new Promise((resolve, reject) => {
        this.image.onload = () => {
          this.result = `// width: ${this.image.width.toString()}, height: ${this.image.height.toString()}\nconst unsigned char ink[] PROGMEM = {\n`;
          
            this.canvas.setAttribute('width', Math.max(this.image.width, this.image.height).toString() + 'px');
            this.canvas.setAttribute('height', Math.max(this.image.width, this.image.height).toString() + 'px');
          
          this.context.clearRect(0, 0, this.image.width, this.image.height);
          this.context.drawImage(this.image, 0, 0);
          this.imageData = this.context.getImageData(0, 0, this.image.width, this.image.height);
          this.width = this.image.width;
          this.height = this.image.height;

          resolve('success');
        }
      })
    }

    loadImage()
    .then(() => {
      this.convertToHex()
      .then(result => {
        this.result += result + '\n};';
        this.dispatch({type: 'success', payload: this.result});
      })
      }
    );
  }

  mirror() {
    const mirror = {horizontal: false, vertical: false};
    mirror[this.options.mirror] = true;

    return new Promise((resolve, reject) => {
      if (!this.file) return;

      Jimp.read(this.file)
      .then(file => {
        return file.flip(mirror.horizontal, mirror.vertical)
        .quality(100)
        .getBase64Async(Jimp.MIME_BMP);
      })
      .then(k => {
        this.file = k;
        resolve('success!');
      })
      .catch(error => console.log('mirror error: ', error));
    })
  }

  convertToHex() {
    return new Promise((resolve, reject) => {
      if (this.options.dither) {
        // this.dither();
      } else {
        this.pickColor()
      }
      if (this.options.invert) {
        this.invertColor()
      }
      resolve(this.getBitmapArray())
    })
  }

  pickColor() {
    let newImageData = this.context.createImageData(this.width, this.height);
    let imageArray = newImageData.data;
    //convert to grayscale
    for (let i = 0; i < imageArray.length; i += 4) {
      let gray = (this.imageData.data[i] * 4 + this.imageData.data[i + 1] * 10 + this.imageData.data[i + 2] * 2) >> 4;
      if (gray < this.options.threshold) {
        imageArray[i] = imageArray[i + 1] = imageArray[i + 2] = 0;
      } else {
        imageArray[i] = imageArray[i + 1] = imageArray[i + 2] = 255;
      }
      imageArray[i + 3] = this.imageData.data[i + 3];
    }

    this.context.putImageData(newImageData, 0, 0);
    this.imageData = newImageData;
  }

  invertColor() {
    let newImageData = this.context.createImageData(this.width, this.height);
    let imageArray = newImageData.data;
    for (let i = 0; i < imageArray.length; i += 4) {
      imageArray[i] = 255 - this.imageData.data[i];
      imageArray[i + 1] = 255 - this.imageData.data[i + 1];
      imageArray[i + 2] = 255 - this.imageData.data[i + 2];
      imageArray[i + 3] = this.imageData.data[i + 3];
    }
    this.context.putImageData(newImageData, 0, 0);
    this.imageData = newImageData;//将翻转颜色后的数据重新保存
  }

  getBitmapArray() {
    let result = '';
    for (let y = 0; y < this.imageData.height; y++) {
      let next_value = 0;
      for (let x = 0; x < this.imageData.width; x++) {
        let n = (y * this.imageData.width + x) * 4//一个像素暴露4个值
        let gray = (this.imageData.data[n] * 4 + this.imageData.data[n + 1] * 10 + this.imageData.data[n + 2] * 2) >> 4;

        if (gray === 255) next_value += Math.pow(2, (7 - (x % 8)));

        if (((x + 1) % 8 === 0 || x === this.imageData.width -1) && (x > 0)) {
          if (this.options.endian) {
            next_value = this.reverseBit(next_value);
          }

          result +='0x' + ('00' + next_value.toString(16)).substr(-2) + ',';
          next_value = 0;
        }
      }
    }

    result = result.slice(0, result.length - 1);
    return result;
  }

  reverseBit(data) {
    let res = 0;
    for (let x = 0; x < 8; x++) {
      res = res << 1;
      res = res | (data & 1);
      data = data >> 1;
    }
    return res;
  }
}

function convertUtils(file, canvas, dispatch, options) {
  let instance = new ConvertUtils(file, canvas, dispatch, options);

  // instance.convert();
  // instance = null;

  instance.mirror().then(() => instance.convert());
}
export {convertUtils};